import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import withTheme from 'core/hocs/withTheme';

import Bullet from '../Bullet';

import bind from 'core/utils/bind';
import themePropTypes from 'core/utils/prop-types/theme';
import { resolveScopedStyles } from 'core/utils/styled-jsx';

import styles from './index.styl';

class Bullets extends PureComponent {
  static propTypes = {
    /**
     * Индекс активного булета.
     *
     * Может изменяться после инициализации.
     */
    currentIndex: PropTypes.number,

    /**
     * Общее число буллетов.
     */
    total: PropTypes.number,

    /**
     * Событие обработки смены активного булета.
     */
    onChange: PropTypes.func,

    /** @ignore */
    theme: themePropTypes(`
      {
        controls: {
          bullets: {
            const: {
              bulletMargin,
            }
          },
      }
    `),
  };

  static defaultProps = {
    currentIndex: 0,
    total: 0,
  };

  state = {
    currentIndex: this.props.currentIndex,
  };

  UNSAFE_componentWillReceiveProps({ currentIndex }) {
    this.setState({ currentIndex });
  }

  onSelect(index) {
    const { onChange } = this.props;
    this.setState({ currentIndex: index }, () => onChange && onChange(index));
  }

  render() {
    const {
      total,
      theme: {
        controls: {
          bullets: bulletsAtoms,
        },
      },
    } = this.props;

    const scope = resolveScopedStyles(
      <scope>
        <style jsx>{`
          .${styles.bullet}
            margin ${bulletsAtoms.const.bulletMargin}
        `}</style>
      </scope>
    );

    const {
      currentIndex,
    } = this.state;

    return (
      <>
        <ul className={styles.bullets}>
          {[...Array(total)].map((item, i) => (
            <li className={scope.wrapClassNames(styles.bullet)} key={i}>
              <Bullet
                active={currentIndex === i}
                onSelect={bind(this.onSelect, this, i)}
              />
            </li>
          ))}
        </ul>
        <scope.styles />
      </>
    );
  }
}

export default withTheme(Bullets);
